import { useQuery, UseQueryResult } from "@tanstack/react-query"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { trpc } from "#/lib/trpc/client"
import { HasCustomNetworksResponse } from "#/pages/provider-finder/types/HasCustomNetworksResponse"

const CUSTOM_NETWORKS_QUERY_KEY = "GetCustomNetworks"

export default function useGetCustomNetworks(): UseQueryResult<HasCustomNetworksResponse, ResponseError> {
  return useQuery<HasCustomNetworksResponse, ResponseError>(
    [CUSTOM_NETWORKS_QUERY_KEY],
    async () => {
      const result = await trpc.member.segmentNetworks.query()
      return {
        hasCustomNetworks: result.hasCustomNetwork,
        isInFertilityNetwork: result.isInFertilityNetwork,
        isInMenopauseNetwork: result.isInMenopauseNetwork,
        isInLowTNetwork: result.isInLowTNetwork
      }
    },
    {
      refetchOnWindowFocus: false,
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}
